import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import { css } from "styled-components"
import Grid from "../../design-system/atoms/layout-primitives/grid.ts"
import Spacer from "../../design-system/atoms/layout-primitives/spacer"
import { T } from "../../design-system/atoms/text"
import ClientsGrid from "../../design-system/organisms/clients-grid"
import { FadeInBottom } from "../shared/keyframes.style"

export default function Clients() {
  const query = useStaticQuery(graphql`
    query {
      desktopLogos: file(
        relativePath: { eq: "0_HOMEPAGE/clients/client logos - desktop.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1440) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      tabletLogos: file(
        relativePath: { eq: "0_HOMEPAGE/clients/client logos - tablet.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1024) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      mobileLogos: allFile(
        filter: { relativeDirectory: { eq: "0_HOMEPAGE/clients/mobile" } }
        sort: { fields: base }
      ) {
        edges {
          node {
            id
            base
            childImageSharp {
              fluid(maxWidth: 600) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
    }
  `)

  return (
    <>
      <Spacer height={{ sm: "48px", md: "64px", lg: "96px" }} />
      <Grid.Animated animation={FadeInBottom} delay="0.5s">
        <ClientsGrid
          title={
            <>
              Our <span>Clients</span>
            </>
          }
          titleVariants={[
            css`
              & > span {
                font-weight: 500;
                color: var(--burnt-orange);
              }
            `,
          ]}
          mobileLogos={query.mobileLogos.edges}
          tabletLogos={query.tabletLogos.childImageSharp.fluid}
          desktopLogos={query.desktopLogos.childImageSharp.fluid}
        />
      </Grid.Animated>
      <Spacer height={{ sm: "64px", lg: "48px" }} />
    </>
  )
}
